/**
 * 系统模块相关权限
 */
export const SYSTEM = {
    /**
     * 用户相关
     */
    USER: {
        /**
         * 用户登录
         */
        LOGIN: "/admin/login",
        /**
         * 获取用户信息
         */
        INFO: "/admin/logininfo",
        /**
         * 用户列表
         */
        USER_LIST: '/admin/admin/list',
        /**
         * 删除用户列表
         */
        DEL_USER: "/admin/admin/del",
        /**
         * 重置密码
         */
        REFRESH_PSW: "/admin/admin/resetPass",
        /**
         * 启用禁用
         */
        ENABLE: "/admin/admin/status",
        /**
         * 添加管理员
         */
        ADD: "/admin/admin/add",
        /**
         * 修改管理员
         */
        EDIT: "/admin/admin/update",
        /**
         * 修改密码
         */
        EDIT_PSW: "/admin/admin/updatepass"
    },
    /**
     * 角色相关
     */
    ROLE: {
        /**
         * 角色列表
         */
        ROLE_LIST: "/admin/role/list",
        /**
         * 删除角色
         */
        DEL: "/admin/role/del",
        /**
         * 启用禁用
         */
        ENABLE: "/admin/role/status",
        /**
         * 添加角色
         */
        ADD: "/admin/role/add",
        /**
         * 修改角色
         */
        EDIT: "/admin/role/update"
    },
    HOME: {
        /**
         * 首页
         */
        HOME: "/admin/statistic/home",
        // 统计排行
        STATISTIC:'/admin/statistic/count',
        // 统计成交金额
        MIUNT:'/admin/statistic/amount'
    },
}
/**
 *
 */
export const SALESMAN = {
    /**
 * 业务员salesman
 */
    BUSINESS: {
        /**
         * 业务员列表
         */
        LIST: "/admin/user/list",
        /**
         * 删除业务员
         */
        DEL: "/admin/user/delete",
        /**
         * 启用禁用
         */
        ENABLE: "/admin/user/status",
        /**
         * 重置密码
         */
        RESETPASS: "/admin/user/resetpass",
        /**
       * 业务员详情
        */
        DETAILS: "/admin/user/info",
        /**
         * 添加业务员
         */
        ADD: "/admin/user/add",
        /**
         * 修改业务员
         */
        EDIT: "/admin/user/update",
        /**
      * 订单列表
      */
        ORDER: '/admin/user/orderlist',
        /**
        *  客户列表
        */
        CUSTOMER: '/admin/user/customerlist'

    }
}
export const COSTOMENT = {
    /**
 * 客户
 */
    MENT: {
        /**
         * 客户列表
         */
        LIST: "/admin/customer/list",
        /**
         * 客户列表
         */
        REGION: "/admin/customer/regionlist",
        /**
         * 转移区客户
         */
        TRANSFERREGION: "/admin/customer/transfer_region",
        /**
         * 全部转移
         */
        TRANSFERWHOLE: "/admin/customer/transfer_whole",
        
        /**
         * 删除客户
         */
        DEL: "/admin/customer/delete",
        /**
        * 客户详情
        */
        DETAILS: "/admin/customer/info",
        /**
         * 添加客户
         */
        ADD: "/admin/customer/add",
        /**
         * 修改客户
         */
        EDIT: "/admin/customer/update",

        // 销售订单列表
        ORDER: '/admin/customer/orderlist',

        // 调整欠款arrears
        ARREARS: '/admin/customer/arrears/change'
    }

}
export const WARE = {
    /**
 * 仓库warehouse
 */
    WAREHOUSE: {
        /**
         * 仓库列表
         */
        LIST: "/admin/ware/list",
        /**
         * 删除仓库
         */
        DEL: "/admin/ware/delete",
        /**
         * 仓库客户
         */
        ADD: "/admin/ware/add",
        /**
         * 修改仓库
         */
        EDIT: "/admin/ware/update",

    },

    /**
* 商品
*/
    GOODS: {
        /**
         * 商品列表
         */
        LIST: "/admin/goods/list",
        /**
         * 删除商品
         */
        DEL: "/admin/goods/delete",
        /**
         *  添加商品
         */
        ADD: "/admin/goods/add",
        /**
         * 更新商品
         */
        EDIT: "/admin/goods/update",
        /**
      * 商品详情
      */
        DETAILS: "/admin/goods/info",
        /**
  * 商品入库inware
  */
        INWARE: "/admin/goods/inware",

        /**商品规格列表 */
        PRICE_LIST:"/admin/goods/pricelist"

    },
    /**
* 商品库存commodity
*/
    COMMODITY: {
        /**
         * 商品库存列表
         */
        LIST: "/admin/goods/warelist",
        /**
         * 商品换库
         */
        DEL: "/admin/stock/change",
        /**
        * 退货厂家
        */
        RETURN: "/admin/goods/returnfactory",
        /**
     * 商品换库
     */
        CHANGE: "/admin/goods/warechange",
        /**换货到厂家 */
        CHANGEFAC: "/admin/goods/addchange",

    },
    // 退款单列表
    RETURNLIST: {
        /**
      * 列表
      */
        LIST: "/admin/goods/returnlist",
        /**
         * 更新
         */
        EDIT: "/admin/goods/updatereturn",
        /**
    * 取消
    */
        CANCEL: "/admin/goods/cancelreturn",

    },
    // 换货单列表
    CHANGELIST: {
        /**
      * 列表
      */
        LIST: "/admin/goods/changelist",
        /**
         * 更新
         */
        EDIT: "/admin/goods/updatechange",
        /**
    * 取消
    */
        CANCEL: "/admin/goods/cancelchange",
    }
}

// 销售单+退货+换货
export const SALE = {
    /**
 * 销售
 */
    ORDER: {
        /**
         * 销售单合计
         */
        COUNT:"/admin/saleorder/sum",
        /**
         * 销售单列表
         */
        LIST: "/admin/saleorder/list",
        
        /**
         * 销售单明细
         */
        GOODSLIST: "/admin/goodsorder/list",
        /**
         * 销售单下单(添加)
         */
        ADD: "/admin/saleorder/add",
        /**
         * 修改销售单
         */
        EDIT: "/admin/saleorder/update",
        // 获取销售单详情
        DETAILS: '/admin/saleorder/info',
        // 添加销售单商品
        ADDGOOD: '/admin/saleorder/addgood',
        //更新销售单商品
        UPDATEGOOD: '/admin/saleorder/updategood',
        // 删除销售单商品
        DELGOOD: '/admin/saleorder/deletegood',
        // 付款
        PAY:'/admin/saleorder/pay',
        CANCEL:'/admin/saleorder/cancel'
    },

    /**
* 退货
*/
    RETURNORDER: {
        /**
         * 退货单列表
         */
        LIST: "/admin/saleorder/returnlist",
        /**
         * 取消退货单
         */
        CANCEL: "/admin/saleorder/cancelreturn",
        /**
         *  添加退货单
         */
        ADD: "/admin/saleorder/addreturn",
        /**
         * 更新退货单
         */
        EDIT: "/admin/saleorder/updatereturn",
    },
    /**
    * 换货单
    */
    CHANGEORDER: {
        /**
         * 换货单库存列表
         */
        LIST: "/admin/saleorder/changelist",
        /**
         *  添加换货单库存
         */
        ADD: "/admin/saleorder/addchange",
        /**
         * 更新换货单库存
         */
        EDIT: "/admin/saleorder/updatechange",
        /**
         * 取消换货单
         */
        CANCEL: "/admin/saleorder/cancelchange",
    },
}

// 采购单+退货+换货
export const PURCHASE = {
/**
 * 采购
 */
    ORDERS: {
        LIST: "/admin/purchaseorder/list",
        CANCEL:'/admin/purchaseorder/cancel',
        DETAILS:'/admin/purchaseorder/info',
        ADD: '/admin/purchaseorder/add',
        EDIT:'/admin/purchaseorder/update',
        // 操作商品
        ADDGOODS:"/admin/purchaseorder/addgood",
        DELGOODS: "/admin/purchaseorder/deletegood",
        EDITGOODS:"/admin/purchaseorder/updategood"


    },


}



// WEBPACK FOOTER //
// ./src/api/api.js